/*
 * Silk Romance - Attention Manager (Next-Phase, section 4)
 * A single lightweight arbiter so engagement features never compete.
 * Only ONE interruptive interaction (exit intent, scroll discovery,
 * support-agent nudge) may be active at a time; each respects a cooldown.
 * Spin & Win's own launcher button is NOT gated (it's a persistent,
 * non-interruptive UI element, not a popup), but if Spin & Win is used as
 * the Exit Intent recovery action, that path IS gated (see sr-exit-intent.js).
 * Never blocks Add to Cart, Buy Now, or Checkout - this module only ever
 * shows/hides its own overlays, it never touches cart/checkout DOM or logic.
 *
 * Priority order per the spec (section 4), highest first:
 *   exit_intent > free_shipping_progress (native, not gated here) >
 *   scroll_discovery > support_agent_invite > recently_viewed
 * Cooldown: 24h per interaction type, stored in localStorage.
 */
(function (window) {
  'use strict';
  var COOLDOWN_MS = 24 * 60 * 60 * 1000;
  var STORAGE_KEY = 'sr_attention_cooldowns_v1';
  var active = null;

  function readCooldowns() {
    try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeCooldowns(obj) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch (e) {}
  }

  function onCooldown(name) {
    var cds = readCooldowns();
    var last = cds[name];
    return !!last && (Date.now() - last) < COOLDOWN_MS;
  }

  function request(name) {
    if (active) {
      if (window.SREvents) window.SREvents.track('attention_manager_suppressed', { requested: name, active_interaction: active });
      return false;
    }
    if (onCooldown(name)) {
      if (window.SREvents) window.SREvents.track('attention_manager_suppressed', { requested: name, reason: 'cooldown' });
      return false;
    }
    active = name;
    var cds = readCooldowns();
    cds[name] = Date.now();
    writeCooldowns(cds);
    if (window.SREvents) window.SREvents.track('attention_manager_triggered', { interaction: name });
    return true;
  }

  function release(name) {
    if (active === name) active = null;
  }

  window.SRAttentionManager = { request: request, release: release, isActive: function () { return active; } };
})(window);
